// eslint-disable-next-line no-restricted-imports
import { hasAccount } from 'common/lib/accounts';
// eslint-disable-next-line no-restricted-imports
import { State } from 'modules';
import { getMe } from './members';
import { getMyTeams } from './teams';

// eslint-disable-next-line no-restricted-imports
import { TeamModel } from 'types';

export const hasMemberAccount = (state: State) => {
  const me = getMe(state);

  return hasAccount(me && me.paidAccount && me.paidAccount.standing);
};

export const hasOrgAccount = (state: State) => {
  const teams = getMyTeams(state);

  return !!teams.some((org: TeamModel) => {
    return hasAccount(org.paidAccount && org.paidAccount.standing);
  });
};

export const hasMemberOrOrgAccount = (state: State) => {
  return hasMemberAccount(state) || hasOrgAccount(state);
};



// WEBPACK FOOTER //
// ./app/gamma/src/selectors/accounts.ts